import { render, staticRenderFns } from "./PsPatientsList.vue?vue&type=template&id=e564f698&scoped=true&"
import script from "./PsPatientsList.vue?vue&type=script&lang=js&"
export * from "./PsPatientsList.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientsList.vue?vue&type=style&index=0&id=e564f698&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e564f698",
  null
  
)

export default component.exports